import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/clients' },
  { path: 'clients', loadChildren: () => import('./features/clients/clients.module').then(m => m.ClientsModule), canActivate: [AuthGuard] },
  { path: 'assessment', loadChildren: () => import('./features/assessment/assessment.module').then(m => m.AssessmentModule), canActivate: [AuthGuard] },
  { path: 'department', loadChildren: () => import('./features/login-logout/components/department/department.module').then(m => m.DepartmentModule), canActivate: [AuthGuard] },
  { path: 'sra-logout', loadChildren: () => import('./features/login-logout/components/log-out/log-out.module').then(m => m.LogOutModule)},
  { path: 'sra-unauthorized', loadChildren: () => import('./features/login-logout/components/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule)},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
